module.exports = __webpack_public_path__ + "videos/tile-effects_cn.16fc940.mp4";